import { render } from "./IconCopyOutline.vue?vue&type=template&id=b2f43fa4"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconCopyOutline.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b2f43fa4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b2f43fa4', __exports__)) {
    api.reload('b2f43fa4', __exports__)
  }
  
  module.hot.accept("./IconCopyOutline.vue?vue&type=template&id=b2f43fa4", () => {
    api.rerender('b2f43fa4', render)
  })

}


export default __exports__